module.exports = __webpack_public_path__ + "img/1.a70958c7.png";